<template>
  <div class="mx-3">
    <v-dialog v-model="dialogadd" max-width="650">
      <v-card>
        <v-card-title class="color-theme white--text">
          <h4 class="font-weight-light pl-3">Add / Edit Special Event</h4>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogadd = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pl-7 pr-5">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <span class="body-2">Name</span>
                  <span class="error--text">*</span>
                  <v-text-field
                    class="text-field-border mr-3"
                    type="text"
                    v-model="item_event.name"
                    placeholder="name"
                    required
                    hide-details="auto"
                    clearable
                    clear-icon="mdi-close mb-2"
                    solo
                    dense
                    flat
                    :rules="nameRules"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" class="mr-9"
                  ><v-avatar
                    class="rounded-lg mt-4"
                    color="grey lighten-2"
                    height="230"
                    width="200"
                  >
                    <v-img :src="item_event.logoUrl" @load="loadingDialog = false"></v-img
                  ></v-avatar>
                </v-col>
                <v-col cols="7">
                  <span class="body-2">Logo</span
                  ><v-file-input
                    placeholder="choose logo"
                    clear-icon="mdi-close mb-2"
                    :rules="!item_event.isEdit ? logoFileRules : logoFileEditRules"
                    accept="image/png, image/jpeg, image/bmp"
                    prepend-icon="mdi-camera"
                    solo
                    dense
                    flat
                    class="text-field-border pl-2"
                    @change="previewLogo"
                    @click:clear="cancelPreviewLogo"
                    v-model="item_event.logoFile"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-6 pr-8">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            class="font-weight-regular button mx-1 text-capitalize"
            width="90"
            @click="closeDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            color="rgb(66, 154, 216)"
            class="font-weight-regular button mx-1 text-capitalize"
            dark
            width="90"
            @click="saveSpecialEvent"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container>
      <v-row>
        <v-col cols="2" class="mr-5"> <h3>Special Event</h3> </v-col></v-row
      >
      <v-row>
        <v-col cols="3">
          <span class="subtitle-2">Search</span>
          <v-text-field
            class="text-field-border subtitle-2"
            placeholder="search name"
            type="text"
            v-model="search_name"
            hide-details="auto"
            clearable
            clear-icon="mdi-close mb-2"
            solo
            dense
            flat
          ></v-text-field>
        </v-col>
        <v-col cols="2">
          <span class="subtitle-2 search-status mt-1">Status</span>
          <v-btn-toggle
            v-model="toggle_search_status"
            mandatory
            color="primary"
            @change="searchStatus"
          >
            <v-btn height="40" class="caption"> all </v-btn>
            <v-btn height="40" class="caption"> active </v-btn>
            <v-btn height="40" class="caption"> unactive </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-col cols="7" class="mt-5 text-right">
          <v-btn
            color="rgb(66, 154, 216)"
            class="ma-2 font-weight-regular"
            dark
            @click="openDialog"
            ><v-icon left> mdi-plus </v-icon>
            Add Special Event
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="item_event_list"
        class="elevation-1"
        hide-default-footer
        :search="search_name"
        :page.sync="item_page.page"
        :items-per-page="item_search.limit"
      >
        <template v-slot:item.logo="{ item }">
          <v-img class="rounded-lg" :src="item.logo" height="45" width="45"></v-img>
        </template>

        <template v-slot:item.name="{ item }">
          <span>{{ item.name }}</span>
        </template>

        <template v-slot:item.status="{ item }">
          <v-switch
            v-model="item.status"
            inset
            @change="openConfirmDialog(item)"
          ></v-switch>
        </template>

        <template v-slot:item.createdate="{ item }">
          <span>{{ item.createdate | moment("DD/MM/YYYY HH:mm") }}</span>
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn
            class="body-2 primary--text text-capitalize"
            color="white"
            @click="editDialog(item)"
            depressed
          >
            Edit
          </v-btn>
        </template>
      </v-data-table>
      <v-row>
        <v-col>
          <v-pagination
            v-model="item_search.page"
            :length="item_page.length"
            @input="getSpecialEventList"
          ></v-pagination>
        </v-col>
      </v-row>
      <!-- loading dialog -->
      <loadingDialog v-bind:ld_dialog.sync="loadingDialog"></loadingDialog>
      <confirmDialog
        v-bind:cf_dialog="confirmWarning.isShow"
        v-bind:cf_title="confirmWarning.title"
        v-bind:cf_text="confirmWarning.text"
        v-bind:cf_color_btn1="confirmWarning.colorBtn"
        @cancel="cancelSpecialActiveEvent"
        @active="activeSpecialEvent"
      >
      </confirmDialog>
      <completeDialog
        v-bind:cm_dialog.sync="completeWarning.isShow"
        v-bind:cm_title="completeWarning.title"
        v-bind:cm_text="completeWarning.text"
        v-bind:cm_color="completeWarning.colorBtn"
        @done="closeSuccesDialog"
      ></completeDialog>
    </v-container>
  </div>
</template>

<script>
import confirmDialog from "@/components/confirmDialog";
import completeDialog from "@/components/completeDialog";
import loadingDialog from "@/components/loadingDialog";
import { uploadImage } from "@/service/upload/upload";
import {
  fetchMarketEvent,
  insertMarketEvent,
  updateActiveMarketEvent,
  updateMarketEvent,
} from "@/service/special_event/special_event";
export default {
  components: {
    confirmDialog,
    completeDialog,
    loadingDialog,
  },
  name: "specialevent",
  data() {
    return {
      dialogadd: false,
      loadingDialog: false,
      valid: true,
      search_name: "",
      toggle_search_status: 0,
      item_event: {
        name: "",
        logoUrl: "",
        logoFile: "",
        isEdit: false,
        oldLogoUrl: "",
      },
      nameRules: [(v) => !!v || "Name is required"],
      logoFileRules: [
        (v) => !!v || "Logo is required",
        (v) => !v || v.size < 20000000 || "Logo size should be less than 2 MB!",
      ],
      logoFileEditRules: [
        (v) => !v || v.size < 20000000 || "Logo size should be less than 2 MB!",
      ],
      item_page: {
        length: 1,
        page: 1,
        page_count: 0,
      },
      item_search: {
        sort: "created_at",
        sortby: -1,
        page: 1,
        limit: 10,
        active: null,
      },
      item_event_list: [],
      completeWarning: {
        isShow: false,
        title: "",
        text: "",
        colorBtn: "",
      },
      item_edit: {
        id: "",
        status: "",
      },
      confirmWarning: {
        isShow: false,
        title: "",
        text: "",
        colorBtn: "",
      },
    };
  },
  mounted() {
    this.getSpecialEventList();
  },
  computed: {
    headers() {
      return [
        {
          text: "logo",
          align: "left",
          sortable: false,
          value: "logo",
        },
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "Status",
          value: "status",
          sortable: false,
          filterable: false,
        },
        {
          text: "Create Date",
          value: "createdate",
          sortable: false,
          filterable: false,
        },
        {
          text: "Edit Special Event",
          value: "action",
          sortable: false,
          filterable: false,
          class: "pl-10",
        },
      ];
    },
  },
  methods: {
    async getSpecialEventList() {
      this.item_event_list = [];
      let result = await fetchMarketEvent(this.item_search);
      if (result) {
        this.item_page.length = result.maxPage;
        result.data.forEach((item) => {
          this.item_event_list.push({
            name: item.title,
            status: item.active,
            logo: item.image,
            id: item._id,
            levelSub: item.levelSub,
            priority: item.priority,
            categories: item.categories,
            createdate: item.created_at,
          });
        });
      }
    },
    closeDialog() {
      this.$refs.form.reset();
      this.dialogadd = false;
    },
    openDialog() {
      this.dialogadd = true;
      this.item_event.logoUrl = "";
      this.item_event.isEdit = false;
    },
    editDialog(item) {
      this.item_event.isEdit = true;
      this.item_event.id = item.id;
      this.item_event.name = item.name;
      this.item_event.logoUrl = item.logo;
      this.item_event.oldLogoUrl = item.logo;
      this.dialogadd = true;
    },
    async saveSpecialEvent() {
      if (this.$refs.form.validate()) {
        let msg = "";
        let msg_body = "";
        let msg_btn = "success";
        if (this.item_event.isEdit) {
          let event = this.item_event_list.filter((event) => {
            return event.id == this.item_event.id;
          });
          let params = event[0];
          params.name = this.item_event.name;
          params.logo = this.item_event.logoUrl;
          let result = await updateMarketEvent(params);
          msg = "Update complete";
          msg_body = "The special event have been successfully updated";
          msg_btn = "success";
          if (result.message) {
            msg = "Can't Update";
            msg_body = result.message;
            msg_btn = "error";
          }
        } else {
          let result = await insertMarketEvent(this.item_event);
          if (result.message) {
            msg = "Can't Save";
            msg_body = result.message;
            msg_btn = "error";
          } else {
            msg = "Insert Complete";
            msg_body = "The special event have been successfully inserted";
          }
        }
        await this.getSpecialEventList();
        this.alertCompleteDialog(msg, msg_body, msg_btn, msg_btn);
        this.closeDialog();
      }
    },
    async previewLogo() {
      if (this.item_event.logoFile.size < 20000000) {
        // let blobUrl = URL.createObjectURL(this.item_event.logoFile);
        this.loadingDialog = true;
        let result = await uploadImage("market_event", this.item_event.logoFile);
        this.item_event.logoUrl = result ? result : this.item_event.logoUrl;
      }
    },
    cancelPreviewLogo() {
      this.item_event.logoUrl = this.item_event.oldLogoUrl;
    },
    openConfirmDialog(item) {
      this.confirmWarning.isShow = true;
      this.item_edit.id = item.id;
      this.item_edit.status = item.status;
      //dialog text
      if (item.status) {
        this.confirmWarning.title = "Do you want to activate ?";
        this.confirmWarning.text =
          "The special event will be activated when you click Confirm.";
        this.confirmWarning.colorBtn = "success";
      } else {
        this.confirmWarning.title = "Do you want to suspend ?";
        this.confirmWarning.text =
          "Once the special event is suspended, you are able to come back and modify the status afterward.";
        this.confirmWarning.colorBtn = "error";
      }
    },
    async activeSpecialEvent(value) {
      let event = this.item_event_list.filter((event) => {
        return event.id == this.item_edit.id;
      });
      if (event.length == 1) {
        let result = await updateActiveMarketEvent(event[0]);
        let msg = "Successfully Saved";
        let msg_body = "You are able to modify the status afterward";
        let type_msg = "success";
        if (result.message) {
          msg = "Can't Saved";
          msg_body = result.message;
          type_msg = "error";
          this.cancelSpecialActiveEvent(false);
        }
        this.alertCompleteDialog(msg, msg_body, type_msg);
        this.item_edit.id = "";
        this.item_edit.status = "";

        if (this.toggle_search_status != 0) {
          this.searchStatus();
        }
      }
      this.confirmWarning.isShow = false;
    },
    cancelSpecialActiveEvent(value) {
      this.item_event_list.forEach((item, idx) => {
        if (item.id == this.item_edit.id) {
          this.item_event_list[idx].status = !this.item_edit.status;
        }
      });
      this.confirmWarning.isShow = value;
    },
    alertCompleteDialog(title, text, color = "success") {
      this.completeWarning.isShow = true;
      this.completeWarning.title = title;
      this.completeWarning.text = text;
      this.completeWarning.colorBtn = color;
    },
    closeSuccesDialog(value) {
      this.completeWarning.isShow = value;
    },
    searchStatus() {
      if (this.toggle_search_status == 1) {
        this.item_search.active = true;
      } else if (this.toggle_search_status == 2) {
        this.item_search.active = false;
      } else {
        this.item_search.active = null;
      }
      this.getSpecialEventList();
    },
  },
};
</script>

<style scoped>
.color-theme {
  background-color: rgb(51, 97, 137);
}

.text-field-border {
  border: 1px solid;
  border-color: rgba(65, 65, 65, 0.3);
  background-color: white;
  height: 40px;
  color: rgb(77, 77, 77);
}

.search-status {
  display: block;
}
</style>
